import * as React from "react";
import { Stack, Button, Snackbar, Alert } from "@mui/material";

type Props = {
    title?: string;
    url?: string; // αν δεν δοθεί, παίρνει window.location.href
};

function buildUrl(raw?: string) {
    if (raw) return raw;
    if (typeof window !== "undefined") return window.location.href;
    return "";
}

export default function ShareActions({ title, url }: Props) {
    const [open, setOpen] = React.useState(false);
    const shareUrl = buildUrl(url);

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setOpen(true);
        } catch {
            // fallback
            try {
                const ta = document.createElement("textarea");
                ta.value = shareUrl;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand("copy");
                document.body.removeChild(ta);
                setOpen(true);
            } catch { }
        }
    };

    const nativeShare = async () => {
        try {
            // @ts-ignore
            if (navigator.share) {
                // @ts-ignore
                await navigator.share({
                    title: title || "Property",
                    text: title ? `Δες αυτό το ακίνητο: ${title}` : "Δες αυτό το ακίνητο",
                    url: shareUrl,
                });
            } else {
                await copyLink();
            }
        } catch {
            // user cancelled -> ignore
        }
    };

    const wa = `https://wa.me/?text=${encodeURIComponent(
        `${title ? title + " – " : ""}${shareUrl}`
    )}`;

    const viber = `viber://forward?text=${encodeURIComponent(
        `${title ? title + " – " : ""}${shareUrl}`
    )}`;

    return (
        <>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                <Button variant="contained" onClick={nativeShare} sx={{ fontWeight: 900 }}>
                    Share
                </Button>
                <Button variant="outlined" onClick={copyLink}>
                    Copy link
                </Button>
                <Button component="a" href={wa} target="_blank" rel="noreferrer" variant="text">
                    WhatsApp
                </Button>
                <Button component="a" href={viber} target="_blank" rel="noreferrer" variant="text">
                    Viber
                </Button>
            </Stack>

            <Snackbar open={open} autoHideDuration={2000} onClose={() => setOpen(false)}>
                <Alert severity="success" variant="filled" onClose={() => setOpen(false)}>
                    Ο σύνδεσμος αντιγράφηκε!
                </Alert>
            </Snackbar>
        </>
    );
}
